import { render, staticRenderFns } from "./PaymentTypesModal.vue?vue&type=template&id=20d27918&lang=pug&"
import script from "./PaymentTypesModal.vue?vue&type=script&lang=ts&"
export * from "./PaymentTypesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports